
import React,{useState,useEffect}from "react";
import tw from "twin.macro";
import "../Components/style.css";
import vendingmachine from "../Images/vendingmachine.png";
import HeaderLogo from "../Images/logo.png";
import { useDispatch } from "react-redux";
import { componentReducer } from "./Redux/ComponentSlice";
import "./style.css"

const Container = tw.div`flex items-center ml-80 `;
const BoxForm = tw.div`flex items-center`;
const OverlayContainer = tw.div`flex justify-center`;
const LeftContainer = tw.div`w-1/2   `;
const RightContainer = tw.div`w-1/2  py-40 bg-gray-200`;

const InputContainer = tw.div` mx-20`

const CenterContainer = tw.div`flex justify-center items-center`;
const Heading = tw.h1`text-4xl mb-8 text-center text-textprimary font-semibold`;

export default () => {

  const dispatch=useDispatch();
  const[user_email,set_user_email]=useState("");
  const onChangeUsername=(e)=>
  {
    set_user_email(e.target.value);
  }
  const[user_password,set_user_password]=useState("");
  const onChangeUserpassword=(e)=>
  {
    set_user_password(e.target.value);
  }
  const sign_in=()=>
  {
    if(user_email==="admin@planext4u.com" && user_password==="Friend@2311")
    {
      dispatch(componentReducer(1));
    }
    else
    {
      alert("Invalid user email password");
    }
  }


  return (
    <Container className="loginbody">
    <BoxForm className="box-form">
      <LeftContainer className="left">
        <OverlayContainer className="overlay">
          <img src={vendingmachine} width="75%" />
        </OverlayContainer>
      </LeftContainer>
      <RightContainer className="right">
        <CenterContainer>
          <img src={HeaderLogo}  />
          </CenterContainer>
        <InputContainer className="inputs">
          <input
          
          value={user_email}
          onChange={(e)=>onChangeUsername(e)}
          
          type="text" placeholder="Email Address" />
          <br />
          <input 
                value={user_password}
                onChange={(e)=>onChangeUserpassword(e)} type="password" placeholder="Password" />
        <br />
        <br />
        <div>
          <p>forget password?</p>
        </div>
        </InputContainer>



        <br />
<CenterContainer>
        <button class="button button--pandora">
          <span onClick={()=>sign_in()}>Sign In</span>
        </button></CenterContainer>
      </RightContainer>
    </BoxForm>
    </Container>
  );
};
